import { fetchCancel, FETCH_START, ReduxState } from "ra-core";
import { all, delay, put, select, takeLatest } from "redux-saga/effects";


function* handleResetLoadingIndicator () {
  yield delay(1.5 * 60 * 1000)

  let count : number = yield select((store: ReduxState) => store.admin.loading)
  count = Math.max(count ?? 0, 0)
  if (count > 0) {
    for(let i = 0; i < count; i++) {
      yield put(fetchCancel())
    }
  }
}

export default function* resetLoadingIndicatorSaga() {
  yield all([
    takeLatest(FETCH_START, handleResetLoadingIndicator)
  ])
}
